var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterLineLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36B275",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#659EDD",
    offset: "30.6917671%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E82E8",
    offset: "76.0816454%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#967EF5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0103\\u8BBE\\u8BA1\\u8D70\\u5DEE\\u7EC6\\u8282",
    transform: "translate(-645.000000, -1061.000000)",
    fillRule: "nonzero",
    stroke: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-twitter",
    transform: "translate(646.000000, 1062.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.1111111,0 C36.0203089,-9.01805001e-16 40,3.97969111 40,8.88888889 L40,31.1111111 C40,36.0203089 36.0203089,40 31.1111111,40 L8.88888889,40 C3.97969111,40 6.01203334e-16,36.0203089 0,31.1111111 L0,8.88888889 C-6.01203334e-16,3.97969111 3.97969111,9.01805001e-16 8.88888889,0 L31.1111111,0 Z M25.5642222,10.6666667 C22.268,10.6666667 19.8428889,13.742 20.588,16.9355556 C16.3444444,16.7224444 12.5815556,14.6893333 10.0631111,11.6 C8.7268889,13.896 9.3708889,16.8982223 11.6435556,18.418 C10.8082222,18.3915556 10.0195556,18.1613333 9.332,17.7786667 C9.27755556,20.1446666 10.9715556,22.3566666 13.4277778,22.8497778 C12.7106667,23.0442222 11.9235556,23.0893334 11.1224444,22.936889 C11.7711111,24.9653334 13.6564444,26.4415556 15.8917777,26.4835556 C13.7451111,28.165111 11.0415556,28.9164444 8.33177778,28.5975556 C10.592,30.0473334 13.2753333,30.892 16.1593333,30.892 C25.642,30.892 30.9977778,22.884 30.6726666,15.702 C31.672889,14.9817777 32.5393334,14.0826667 33.2222222,13.0622222 C32.3075556,13.4682222 31.322889,13.742 30.29,13.8664444 C31.343111,13.2348889 32.152,12.2346667 32.5346666,11.0415556 C31.546889,11.6264444 30.4533334,12.0511111 29.2897778,12.2797778 C28.3595556,11.2857778 27.031111,10.6666667 25.5642222,10.6666667 Z",
    id: "\\u5F62\\u72B6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLineLight);
export default __webpack_public_path__ + "static/media/twitter_line_light.3282af171b07a10e8084266185d4b9de.svg";
export { ForwardRef as ReactComponent };